import React from 'react';
import Vimeo from '@u-wave/react-vimeo';
import { Modal, LargeButton } from '..';
import { VideoTourWrapper, Title, Strong, Video, Footer, Info, ButtonWrapper } from './styles';

/**
 * modal with the video tour when the user logs in for the first time
 * 
 * @param params.callback - callback that is executed when the user clicks on the start button in the modal
 * @returns The modal is returned with the video hosted on vimeo with the onboarding to the coach portal
 */
export default ({ callback }: { callback: Function }) => {
  return (
    <Modal width={'608px'} responsive={true} margin="15vh auto 200px auto" padding={'31px 16px'}>
      <VideoTourWrapper data-cy="video-tour">
        <Title>WELCOME TO THE <Strong> COACHES PORTAL</Strong></Title>
        <Video>
          <Vimeo
            controls={true}
            responsive={true}
            video={'https://vimeo.com/659780853'}
          />
        </Video>
        <Footer>
          <Info>You can watch this video later by going to the menu / <Strong>how to do videos</Strong></Info>
          <ButtonWrapper>
            <LargeButton
              fullWidth
              type="submit"
              fSize={'16px'}
              bradius={'8px'}
              rColor="#017CFF"
              bColor="#FFFFFF"
              dataCy="login-button"
              title="Get Started"
              colorDisabled={'#B3D7FF'}
              callback={callback}
            />
          </ButtonWrapper>
        </Footer>
      </VideoTourWrapper>
    </Modal>
  )
}